import React from 'react';
import PropTypes from 'prop-types';
import styles from '../shared/styles';
import Toggle from 'react-toggle';
import { HigherPlanTag } from '../../../../styles/styled';
import ToggleWithInput from '../common/ToggleWithInput';

const AudioProcessing = (props) => {
  const {
    soundcast,
    accessible,
    trimSilence,
    audioNormalization,
    reduceSilence,
    silentPeriod,
    overlayDuration,
    addIntroOutro,
    hasIntroOutro,
    onNoIntroOutroAlert,
    onChangeOption
  } = props;

  const { intro = false, outro = false } = soundcast;

  return (
    <div className="row">
      <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
        <hr style={styles.audioProcessingHorizontalLine} />
        <div>
          <span style={{ ...styles.miniHeaderText, fontSize: '1.7rem', fontWeight: 800 }}>
            Audio Processing
          </span>
          {!accessible && <HigherPlanTag className="margin-one-left" />}
        </div>
        <div style={{ marginTop: 15 }}>
          <div style={styles.toggleOptionsContent}>
            <Toggle
              className="toggle-green"
              id="audio-edit-2"
              aria-labelledby="audio-edit-2-label"
              checked={trimSilence}
              onChange={onChangeOption('trimSilence', !trimSilence)}
            />
            <div id="audio-edit-2-label" style={styles.optionToggleWrapper}>
              <div style={styles.optionToggleMainText}>Trim silence at the beginning</div>
            </div>
          </div>
          <div style={styles.toggleOptionsContent}>
            <Toggle
              className="toggle-green"
              id="audio-edit-1"
              aria-labelledby="audio-edit-1-label"
              // label="Charge subscribers for this soundcast?"
              checked={audioNormalization}
              onChange={onChangeOption('audioNormalization', !audioNormalization)}
            />
            <div id="audio-edit-1-label" style={styles.optionToggleWrapper}>
              <div style={styles.optionToggleMainText}>Optimize volume</div>
              <div style={styles.optionToggleSubText}>
                (This is to make sure different parts of your audio have consistent volume,
                and adjust the volume to the most suitable level for mobile and web playing )
              </div>
            </div>
          </div>
          <ToggleWithInput
            mainFlag={reduceSilence}
            onChangeValueFn={e => onChangeOption('silentPeriod', Number(e.target.value))()}
            inputValue={silentPeriod}
            onChangeToggleFn={onChangeOption('reduceSilence', !reduceSilence)}
            mainText={'Remove excessive silence/pauses throughout'}
            subText={'(This option will remove all silent periods in the recording that\'re longer\n' +
            '                than specified seconds. It\'s good for tightening up your recording. But don\'t\n' +
            '                use this if you have silent periods in your recording on purpose.)'}
            inputLabel={'Remove silent periods longer than: '}
            inputUnits={'second(s)'}
          />
          <ToggleWithInput
            mainFlag={addIntroOutro}
            onChangeToggleFn={() => {
              if (intro || outro) {
                onChangeOption('addIntroOutro', !addIntroOutro)();
              } else {
                onNoIntroOutroAlert();
              }
            }}
            inputValue={overlayDuration}
            onChangeValueFn={e => onChangeOption('overlayDuration', Number(e.target.value))() }
            mainText={'Attach intro and outro'}
            subText={'(Please upload an intro and/or outro for your soundcast first)'}
            inputLabel={'Overlap with main audio: '}
            inputUnits={'second(s)'}
          />
        </div>
      </div>
    </div>
  );
};

AudioProcessing.propTypes = {
  soundcast: PropTypes.object,
  accessible: PropTypes.bool,
  trimSilence: PropTypes.bool,
  audioNormalization: PropTypes.bool,
  reduceSilence: PropTypes.bool,
  silentPeriod: PropTypes.number,
  overlayDuration: PropTypes.number,
  addIntroOutro: PropTypes.bool,
  hasIntroOutro: PropTypes.bool,
  onNoIntroOutroAlert: PropTypes.func,
  onChangeOption: PropTypes.func,
};

AudioProcessing.defaultProps = {
  soundcast: {},
  accessible: false,
  trimSilence: false,
  audioNormalization: false,
  reduceSilence: false,
  silentPeriod: 0.5,
  overlayDuration: 5,
  addIntroOutro: false,
  hasIntroOutro: false,
  onNoIntroOutroAlert: () => {},
  onChangeOption: () => {},
};

export default AudioProcessing;
